module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/green_yoga-fd2516541966840692c79e70a0f999a3.png";